const categoriesNameEn = {
  "Main expenses": "Main expenses",
  Products: "Products",
  Car: "Car",
  "Self care": "Self care",
  "Child care": "Child care",
  "Household products": "Household products",
  Education: "Education",
  Leisure: "Leisure",
  "Other expenses": "Other expenses",
  Entertainment: "Entertainment",
  Income: "Income",
};

export default categoriesNameEn;
